// This file was automatically generated from render.reqActFeedItemNew.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.reqActFeedItemNew');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appchart.letters.unreadAlertNotification');
goog.require('el8.template.ptdata.letterReceiptsNew');
goog.require('el8.template.ptdata.lettersNew');
goog.require('el8.template.ptdata.model.attachment');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.message');
goog.require('el8.template.ptdata.model.order');
goog.require('el8.template.ptdata.reports');
goog.require('el8.template.render.chartFeedItemNew');
goog.require('el8.template.render.chartReqActFeedItemSharedNew');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.reportItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight report-item"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">', (opt_data.report.reportType == 'lab') ? '<div class="el8ChartFeedIconLabReport"></div>' : (opt_data.report.formCollection) ? '<div class="el8ChartFeedIconFormCollection"></div>' : '<div class="el8ChartFeedIconReport"></div>', '</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainTopLine"><a class="el8FeedItemColMainTopLineLink details-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.ptdata.reports.summary(soy.$$augmentData(opt_data.report, {doHighlight: true}), output);
  output.append('</a></div>');
  if (opt_data.report.abnormalResultNames.length) {
    output.append('<div class="el8FeedColMainLine">');
    el8.template.ptdata.reports.abnormalSummary(opt_data.report, output);
    output.append('</div>');
  }
  output.append((opt_data.report.reviewUserName) ? '<div class="el8FeedColMainLine">Assigned to ' + soy.$$escapeHtml(opt_data.report.reviewUserName) + '</div>' : '', (opt_data.report.reportType == 'lab' && opt_data.report.collectedDate) ? '<div class="el8FeedColMainLine">Collected ' + (soy.$$escapeHtml(opt_data.report.collectedDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.report.collectedDate)) : '') + '</div>' : '', (opt_data.report.reportType != 'lab' && opt_data.report.documentDate) ? '<div class="el8FeedColMainLine">Dated ' + (soy.$$escapeHtml(opt_data.report.documentDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(opt_data.report.documentDate)) : '') + '</div>' : '');
  if (opt_data.report.noteItems.length) {
    output.append('<div class="el8FeedColMainLine">');
    el8.template.ptdata.reports.noteListSummaryNEW(opt_data.report, output);
    output.append('</div>');
  }
  if (opt_data.referringThreads.length > 0) {
    output.append('<div class="el8FeedColMainLine">');
    var threadList30939 = opt_data.referringThreads;
    var threadListLen30939 = threadList30939.length;
    for (var threadIndex30939 = 0; threadIndex30939 < threadListLen30939; threadIndex30939++) {
      var threadData30939 = threadList30939[threadIndex30939];
      el8.template.ptdata.model.message.referencedFeedSummary(threadData30939, output);
    }
    output.append('</div>');
  }
  output.append((opt_data.isSignOffAllowed && el8Globals.FEATURES.Letters) ? '<div class="el8InlineDialogContainer"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="el8button chartSignOffTrigger el8PrimaryButton ebs-btn ebs-btn-primary" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' + ((opt_data.isPhysician) ? 'Sign Off' : (opt_data.isStaffReviewAllowed) ? 'Mark as Reviewed' : '') + '</button></li>' + ((el8Globals.FEATURES.PatientPortal && ! opt_data.report.formCollection && opt_data.isPhysician) ? '<li class="el8ButtonItem"><button type="button" class="el8button send-report-patient-trigger el8SecondaryButton ebs-btn ebs-btn-default" data-id="' + soy.$$escapeHtml(opt_data.report.id) + '">Sign Off &amp; Send to Patient</button></li>' : '') + ((! opt_data.report.formCollection && opt_data.isPhysician) ? '<li class="el8ButtonItem"><button type="button" class="el8button send-report-consultant-trigger el8SecondaryButton ebs-btn ebs-btn-default" data-id="' + soy.$$escapeHtml(opt_data.report.id) + '">Sign Off &amp; Send to Provider</button></li>' : '') + '</ul></div>' : '', '<div class="el8FeedItemColSource">');
  el8.template.render.chartFeedItemNew.plrImportableSource(opt_data, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.orderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.order.signDate && opt_data.order.currentState == 'outstanding') {
    el8.template.render.chartFeedItemNew.orderItemBase(soy.$$augmentData(opt_data, {isRA: false}), output);
  } else {
    el8.template.render.chartFeedItemNew.orderItemBase(soy.$$augmentData(opt_data, {isRA: true}), output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.medOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.medOrderItemBase(soy.$$augmentData(opt_data, {isRA: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.rxRefillRequestMedicationHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append(soy.$$escapeHtml(opt_data.refillMedication.requestedMedicationName), ' ', (opt_data.refillMedication.directions) ? 'sig: ' + soy.$$escapeHtml(opt_data.refillMedication.directions) : '', (opt_data.refillMedication.quantity) ? ' #' + soy.$$escapeHtml(opt_data.refillMedication.quantity) : '', (opt_data.refillMedication.isPrn) ? ' RFx(PRN)' : (opt_data.refillMedication.requestedRefills > 0) ? ' RFx' + soy.$$escapeHtml(opt_data.refillMedication.authRefills) : '', (opt_data.refillMedication.displaySubstitutions) ? ' ' + soy.$$escapeHtml(opt_data.refillMedication.displaySubstitutions) : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.rxRefillRequestMedication = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedItemColMainSubHead">', soy.$$escapeHtml(opt_data.medType), ':</div><p class="el8MoreLineHeight"><a class="rx-refill-detail-trigger el8TriggerLink" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.render.reqActFeedItemNew.rxRefillRequestMedicationHeader({refillMedication: opt_data.refillMedication}, output);
  output.append('</a></p>', (opt_data.refillMedication.note) ? '<p class="el8MoreLineHeight">Pharmacy Note: ' + soy.$$escapeHtml(opt_data.refillMedication.note) + '</p>' : '', (opt_data.refillMedication.writtenDate || opt_data.refillMedication.lastFillDate) ? '<div class="el8Spacer">' + ((opt_data.refillMedication.writtenDate || opt_data.refillMedication.lastFillDate) ? '<p class="el8Italic">Script' + ((opt_data.refillMedication.writtenDate) ? ' written on ' + soy.$$escapeHtml(opt_data.refillMedication.writtenDate) : '') + ((opt_data.refillMedication.lastFillDate) ? ((opt_data.refillMedication.writtenDate) ? ' and' : '') + ' was last filled on ' + soy.$$escapeHtml(opt_data.refillMedication.lastFillDate) : '') + '.</p>' : '') + '</div>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.rxRefillRequest = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconRefillMed"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainTopLine">', (opt_data.followupNumber) ? '[Follow up #' + soy.$$escapeHtml(opt_data.followupNumber) + ' from pharmacy] ' : '', 'Refill Request: ', (opt_data.isControlled) ? '(Controlled Substance) ' : '', '<a class="rx-refill-detail-trigger el8TriggerLink" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">');
  el8.template.render.reqActFeedItemNew.rxRefillRequestMedicationHeader({refillMedication: opt_data.dispensedMedication}, output);
  output.append('</a></div><div class="el8FeedColMainLine">from ', soy.$$escapeHtml(opt_data.pharmacyName), ' ', (opt_data.pharmacyPhone) ? '(ph: ' + soy.$$escapeHtml(opt_data.pharmacyPhone) + ') ' : '', 'assigned to ', soy.$$escapeHtml(opt_data.prescriberName), '</div>');
  el8.template.render.reqActFeedItemNew.rxRefillRequestMedication({medType: 'Prescribed', refillMedication: opt_data.prescribedMedication, feedItemId: opt_data.feedItemId}, output);
  output.append('<hr class="el8Dashed">');
  el8.template.render.reqActFeedItemNew.rxRefillRequestMedication({medType: 'Dispensed', refillMedication: opt_data.dispensedMedication, feedItemId: opt_data.feedItemId}, output);
  if (opt_data.originalMedOrder) {
    output.append('<hr class="el8Dashed"><div class="el8FeedItemColMainSubHead">Original Prescription Written:</div><p class="el8MoreLineHeight"><a class="details-trigger" _fid="MedOrder_', soy.$$escapeHtml(opt_data.originalMedOrder.id), '">');
    el8.template.ptdata.model.medOrder.baseSummary(opt_data.originalMedOrder, output);
    output.append('</a></p>');
  }
  output.append((! opt_data.dispensedAsPrescribed) ? '<span class="el8FeedItemAbnormalText">* Medication may not have been dispensed as prescribed. *</span>' : '', (opt_data.userCanAddress && ! el8Globals.READ_ONLY) ? '<div class="el8InlineDialogContainer"><ul class="el8ButtonContainer">' + ((opt_data.isReadyToAccept && opt_data.userCanApprove) ? '<li class="el8ButtonItem"><button type="button" class="el8button rx-refill-approve-trigger el8PrimaryButton ebs-btn ebs-btn-primary" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Approve</button></li>' : '') + ((opt_data.userCanApprove) ? '<li class="el8ButtonItem"><button type="button" class="el8button rx-refill-edit-trigger el8SecondaryButton ebs-btn ebs-btn-default" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Change Number of Refills</button></li>' : '') + ((opt_data.isControlled) ? '<li class="el8ButtonItem"><button type="button" class="el8button rx-refill-renew-trigger el8PrimaryButton ebs-btn ebs-btn-default" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Renew</button></li>' : '') + '<li class="el8ButtonItem"><button type="button" class="el8button rx-refill-deny-trigger el8SecondaryButton ebs-btn ebs-btn-default" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Deny</button></li></ul><div class="rx-refill-edit-detail"></div><div class="rx-refill-deny-detail"></div><div class="rx-refill-renew-detail"></div></div>' : '', '</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.rxHistoryDownload = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconRxDownload"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainTopLine"><a class="view-fills-trigger" data-id="', soy.$$escapeHtml(opt_data.summaryItem.id), '">', soy.$$escapeHtml(opt_data.summaryItem.description), '</a></div>', (opt_data.summaryItem.eligPbmName) ? '<div class="el8FeedColMainLine">Source: Patient\'s Pharmacy Benefits Manager ' + soy.$$escapeHtml(opt_data.summaryItem.eligPbmName) + '</div>' : '', '</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.visitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconVisitNote"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainTopLine">', (opt_data.bill && opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.UnresolvedError) ? 'Bill Failed: ' : '', (! opt_data.signDate) ? '<a class="visit-note-trigger" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">In Progress: ' + soy.$$escapeHtml(opt_data.description) + '</a>' : '<a class="item-details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' + soy.$$escapeHtml(opt_data.description) + '</a>', '</div>', (opt_data.headerSummary) ? '<div class="el8FeedColMainLine">' + soy.$$escapeHtml(opt_data.headerSummary) + '</div>' : '', '<div class="el8FeedColMainLine">by ', soy.$$escapeHtml(opt_data.physicianFullName), '</div>', (opt_data.bill && opt_data.bill.billingStatus == el8.util.consts.BILLING_STATUS.UnresolvedError) ? '<div class="el8FeedColMainLine el8Ellipsis bill-error-text">Error: ' + soy.$$escapeHtml(opt_data.bill.billingError) + '</div>' : '', '</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.visitNoteEdit = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconVisitNote"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColMainTopLine"><a class="visit-note-edit-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">In Progress: ', soy.$$escapeHtml(opt_data.description), '</a></div>', (opt_data.headerSummary) ? '<div class="el8FeedColMainLine">' + soy.$$escapeHtml(opt_data.headerSummary) + '</div>' : '', '<div class="el8FeedColMainLine">by ', soy.$$escapeHtml(opt_data.createUserName), '</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.reactItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.messageThread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconMessage"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainTopLine">');
  var memberList31202 = opt_data.members;
  var memberListLen31202 = memberList31202.length;
  for (var memberIndex31202 = 0; memberIndex31202 < memberListLen31202; memberIndex31202++) {
    var memberData31202 = memberList31202[memberIndex31202];
    output.append((el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(memberData31202.name)) : soy.$$escapeHtml(memberData31202.name)), (! (memberIndex31202 == memberListLen31202 - 1)) ? ', ' : '');
  }
  output.append('</div>', (opt_data.isPostDated) ? '<div class="el8FeedColMainLine">Message will be delivered on ' + (soy.$$escapeHtml(opt_data.deliveryDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.deliveryDate)) : '') + '</div>' : '');
  if (opt_data.useNewMessages) {
    output.append('<div id="', soy.$$escapeHtml(opt_data.feedId), '-messages" class="el8NewMessageWrapper"></div>');
  } else {
    output.append('<div class="el8MessageWrapper">');
    var messageList31223 = opt_data.messages;
    var messageListLen31223 = messageList31223.length;
    for (var messageIndex31223 = 0; messageIndex31223 < messageListLen31223; messageIndex31223++) {
      var messageData31223 = messageList31223[messageIndex31223];
      output.append('<div class="el8MessageContent"><div class="el8MsgAvatar"><img src="/user/', soy.$$escapeHtml(messageData31223.senderId), '/photo/profile/24/24/" /></div><div class="el8MessageMetaData"><span class="el8MessageAuthor ', (messageData31223.isPhysician) ? 'el8PhysicianText' : 'el8StaffTextNew', '">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(messageData31223.senderName)) : soy.$$escapeHtml(messageData31223.senderName)), '</span><span class="el8MessageTimeStamp">', (soy.$$escapeHtml(messageData31223.sendDate)? el8.service.tz.soyDateTime(soy.$$escapeHtml(messageData31223.sendDate)) : ''), '</span></div><div class="el8MessageText el8Preserve ', (messageData31223.isPhysician) ? 'åel8PhysicianText' : 'el8StaffTextNew', '">', (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(messageData31223.body)) : soy.$$escapeHtml(messageData31223.body)), '</div>', (messageData31223.docId) ? '<p class="el8AppText el8Ellipsis">Re: <a class="item-details-trigger" data-id="' + soy.$$escapeHtml(messageData31223.docId) + '">' + messageData31223.docSummary + '</a></p>' : (messageData31223.docPlaceholder) ? '<p class="el8AppText el8Ellipsis">Re: ' + soy.$$escapeHtml(messageData31223.docPlaceholder) + '</p>' : '', '</div>');
    }
    output.append((! opt_data.signDate) ? ((! el8Globals.READ_ONLY) ? '<div id="threadReplyTrigger_' + soy.$$escapeHtml(opt_data.id) + '" class="threadReplyTrigger el8FieldTrigger el8StandardFontSize" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">Reply...</div>' : '') + '<div class="threadPane_' + soy.$$escapeHtml(opt_data.id) + '"></div>' : '', '</div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.nonvisitNote = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconNonVisitNote"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColMainTopLine"><a class="nonvisit-note-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">In Progress: ', soy.$$escapeHtml(opt_data.description), '</a></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.incomingDirectMessage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight direct-message-item" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" data-id="', soy.$$escapeHtml(opt_data.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconNonVisitNote"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainContainer"><div class="el8FeedItemColMainTopLine">Direct Message from ', soy.$$escapeHtml(opt_data.fromAddress), '</div><div class="el8FeedColMainLine el8SingleLineText"><span class="el8555">Re: ', soy.$$escapeHtml(opt_data.subject), '</span></div><div class="letter-collapsible-section"><p class="el8Preserve el8BreakWord mt10 mb20">', soy.$$escapeHtml(opt_data.content), '</p>');
  if (opt_data.attachments.length) {
    output.append('<p class="el8AppLightText padv5">Attachments to be filed:</p><ol class="el8FieldShortLabelPadding mb10">');
    var itemFileNameList31309 = opt_data.attachments;
    var itemFileNameListLen31309 = itemFileNameList31309.length;
    for (var itemFileNameIndex31309 = 0; itemFileNameIndex31309 < itemFileNameListLen31309; itemFileNameIndex31309++) {
      var itemFileNameData31309 = itemFileNameList31309[itemFileNameIndex31309];
      output.append((itemFileNameData31309 != opt_data.ccdaContentFileName) ? '<li class="el8BulletText">' + soy.$$escapeHtml(itemFileNameData31309) + '</li>' : '');
    }
    output.append((opt_data.ccdaContentFileName) ? '<li class="el8BulletText">Patient Summary C-CDA</li>' : '', '</ol>');
  }
  output.append('</div></div><div class="el8FeedItemColMainContainer"></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.nonvisitNoteAsIncomingDirectMessage = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight nonvisit-note-item" data-patient-id="', soy.$$escapeHtml(opt_data.patient.id), '" data-id="', soy.$$escapeHtml(opt_data.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconNonVisitNote"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainContainer"><div class="el8FeedItemColMainTopLine">Direct Message from ', soy.$$escapeHtml(opt_data.fromAddress), '</div><div class="letter-collapsible-section"><p class="el8Preserve el8BreakWord mt10 mb20">', soy.$$escapeHtml(opt_data.content), '</p>');
  if (opt_data.attachments.length) {
    output.append('<p class="el8AppLightText padv5">Attachments to be filed:</p><ol class="el8FieldShortLabelPadding mb10">');
    var itemList31342 = opt_data.attachments;
    var itemListLen31342 = itemList31342.length;
    for (var itemIndex31342 = 0; itemIndex31342 < itemListLen31342; itemIndex31342++) {
      var itemData31342 = itemList31342[itemIndex31342];
      if (itemData31342.originalFilename != opt_data.ccdaContentFileName) {
        output.append('<li class="el8BulletText"><a target="_blank" rel="noopener" href="', soy.$$escapeHtml(itemData31342.downloadUrl), '" tabindex="-1">');
        el8.template.ptdata.model.attachment.summary(itemData31342, output);
        output.append('</a></li>');
      }
    }
    output.append((opt_data.xmlPatientSummary) ? '<li class="el8BulletText"><a class="view-xml-summary" data-id="' + soy.$$escapeHtml(opt_data.xmlPatientSummary.id) + '">Patient Summary C-CDA</a></li>' : '', '</ol>');
  }
  output.append('</div></div><div class="el8FeedItemColMainContainer"></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.letterItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight letter-item" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '" data-id="', soy.$$escapeHtml(opt_data.letter.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">');
  el8.template.ptdata.lettersNew.feedIcon(opt_data.letter, output);
  output.append('</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div>');
  if (! opt_data.letter.signDate) {
    output.append('<div class="el8FeedItemColMainTopLine"><a class="unsigned-letter-trigger" _fid="', soy.$$escapeHtml(opt_data.feedItemId), '">In Progress: ');
    el8.template.ptdata.lettersNew.reqActTitleUnsigned(opt_data, output);
    output.append('</a></div><p class="el8FeedColMainLine el8SingleLineText">');
    el8.template.ptdata.lettersNew.reqActSubjectUnsigned(opt_data, output);
    output.append('</p>');
  } else {
    output.append('<div class="el8FeedItemColMainContainer">');
    el8.template.ptdata.lettersNew.signedSummaryNew(soy.$$augmentData(opt_data, {noHighlight: true}), output);
    output.append('</div><div class="el8FeedItemColMainContainer">');
    el8.template.ptdata.lettersNew.secondarySection(soy.$$augmentData(opt_data, {noHighlight: true}), output);
    output.append('</div>');
  }
  output.append('</div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.letterReceipt = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight letter-receipt-item" data-id="', soy.$$escapeHtml(opt_data.letterReceipt.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">');
  el8.template.ptdata.letterReceiptsNew.feedIcon(opt_data.letterReceipt, output);
  output.append('</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainContainer">');
  el8.template.ptdata.letterReceiptsNew.summaryNew(soy.$$augmentData(opt_data.letterReceipt, {noHighlight: true}), output);
  output.append('</div><div class="el8FeedItemColMainContainer">');
  el8.template.ptdata.letterReceiptsNew.secondarySection(soy.$$augmentData(opt_data.letterReceipt, {noHighlight: true}), output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.unreadLetterNotificationItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight unread-letter-notification-item" data-id="', soy.$$escapeHtml(opt_data.unreadLetterNotification.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon">', (opt_data.letter.isSendToPatient) ? '<div class="el8ChartFeedIconPtLetterAlert"></div>' : '<div class="el8ChartFeedIconLetterAlert"></div>', '</div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainTopLine el8Ellipsis">Not opened by recipient -- ');
  el8.template.appchart.letters.unreadAlertNotification.feedSummary(soy.$$augmentData(opt_data, {linkToDetail: true}), output);
  output.append('</div><div class="el8FeedColMainLine el8Ellipsis">');
  el8.template.appchart.letters.unreadAlertNotification.unsignedSummary(opt_data, output);
  output.append('</div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.documentReminderNotificationItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="', soy.$$escapeHtml(opt_data.feedId), '" class="el8FeedItemNew am-highlight reminder-notification-item" data-id="', soy.$$escapeHtml(opt_data.documentReminderNotification.id), '"><div class="el8FeedItemNewWrapper">');
  el8.template.render.chartFeedItemNew.dateColumn(opt_data, output);
  output.append('<div class="el8FeedItemColIcon"><div class="el8ChartFeedIconLetterAlert"></div></div><div class="el8FeedItemColMain"><div class="el8FeedItemColActions">');
  el8.template.render.chartReqActFeedItemSharedNew.actions({actions: opt_data.actions, feedItemId: opt_data.feedItemId}, output);
  output.append('</div><div class="el8FeedItemColMainTopLine el8Ellipsis"><a class="item-details-trigger" data-id="', soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.order.id), '"><!-- Sleep to Generic order UI reskin -->', (opt_data.documentReminderNotification.reminder.forDocumentOrderType == 'sleep' && el8Globals.FEATURES.GenericOrder) ? 'Order' : (soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.forDocumentOrderType)? soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.forDocumentOrderType).capitalize() : '') + ' Order', ' Reminder</a>', (opt_data.documentReminderNotification.reminder.order.dateForTest) ? ' <span class="el8FontSmall el8999">Scheduled for: ' + (soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.order.dateForTest)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.documentReminderNotification.reminder.order.dateForTest)) : '') + '</span>' : '', '</div><div class="el8FeedColMainLine">');
  el8.template.ptdata.model.order.orderFeedSummary({order: opt_data.documentReminderNotification.reminder.order, noExtraInfo: true}, output);
  output.append('</div><div class="el8InlineDialogContainer"><ul class="el8ButtonContainer"><li class="el8ButtonItem"><button type="button" class="el8button reminder-notification-fulfill-trigger el8PrimaryButton ebs-btn ebs-btn-primary">Fulfilled</button></li><li class="el8ButtonItem"><button type="button" class="el8button reminder-notification-remind-later-trigger el8SecondaryButton ebs-btn ebs-btn-default">Remind Later</button></li></ul></div></div></div></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.xmlSummaryItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.xmlSummaryItem(soy.$$augmentData(opt_data, {isRA: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.hl7MessageItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.hl7MessageItem(soy.$$augmentData(opt_data, {isRA: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.plrCollaboratorNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.plrCollaboratorNotification(soy.$$augmentData(opt_data, {isRA: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.vipAccessNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.vipAccessNotification(soy.$$augmentData(opt_data, {isRA: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.pmpCheckNotification = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.pmpCheckNotification(soy.$$augmentData(opt_data, {isRA: true}), output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.reqActFeedItemNew.prenatalFlowsheetVisitMeasurements = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.render.chartFeedItemNew.prenatalFlowsheetVisitMeasurements(soy.$$augmentData(opt_data, {isRA: true}), output);
  if (!opt_sb) return output.toString();
};
